/**
 * @summary  Indicates the current status.
 */
export enum CatalogStatus
{
    
    /**
     * @summary  The item is active
     */
    Active = 0,

    /**
     * @summary  The item is archived
     */    
    Archived = 1,
}